// 新协议
function kkmhhybrid_logout (opt) {
	hybrid({
		hybridParam: {
			schema: "kkmhhybrid",
			tagname: "logout",
		},
		param: {},
		callback: function (res) {
			opt.callback && opt.callback(res);
		}
	})
}

// 旧协议
function kkhybrid_logout(opt) {
	hybrid({
		hybridParam: {
			schema: "kkhybrid",
			tagname: "logout",
		},
		callback: function (res) {
			opt.callback && opt.callback(res);
		}
	})
}

/**
 * 获取设备信息<br>
 * kkmhhybrid://logout，wiki地址：{@link https://wiki.quickcan.com/pages/viewpage.action?pageId=84246854}<br>
 * kkhybrid://logout，wiki地址：{@link https://wiki.quickcan.com/pages/viewpage.action?pageId=51611403}<br>
 * @param {Object} opt 参数对象
 * @param {Function} opt.callback 回调函数
 * @param {Number} criticalAppVersion 新旧协议兼容的判断版本（默认值在hybrid/index.js里配置），客户端版本小于该值使用旧协议，其余使用新协议
 */
function logout (opt, criticalAppVersion) {
	let allow = window.kkBaseInfo.allowToKkmhhybrid(criticalAppVersion);
	if(allow) {
		// 调用新协议
		kkmhhybrid_logout(opt);
	} else {
		// 调用旧协议
	    	kkhybrid_logout(opt);
	}
}

export default logout;



// WEBPACK FOOTER //
// ./node_modules/@kk/h5-sdk/src/logout/index.js